import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { tokenize } from "../../actions/auth";
import { useNavigate } from "react-router-dom";
import { surveyTokenizeDestination } from "../../utils/survey-tokenize";

export const Tokenize = ({ tokenize }) => {
    
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const destination = surveyTokenizeDestination(new URLSearchParams(window.location.search).get("next"));

    useEffect(() => {
        const persistData = async () => {
            // Retrieve URL parameters
            const params = new URLSearchParams(window.location.search);
            const token = params.get("t");
            const instance = params.get("i");
            if (!token || !instance) {
                setError("This sign-in link is incomplete. Please return to your survey and sign in again.");
                return;
            }
            try {
                if (await tokenize(instance, token)) {
                    navigate(destination, { replace: true });
                } else {
                    setError("Sign-in could not be completed. Please return to your survey and sign in again.");
                }
            } catch {
                setError("Sign-in could not be completed. Please return to your survey and sign in again.");
            }
        }
        persistData();
    }, [tokenize, navigate, destination]);

    return (
        <main aria-live="polite" className="d-flex min-vh-100 align-items-center justify-content-center flex-column p-3 text-center">
            <p role={error ? "alert" : undefined}>{error || "Opening your survey\u2026"}</p>
            {error && <a href={destination} className="btn btn-outline-primary">Return to survey</a>}
        </main>
    );
    
}

export default connect(null, { tokenize })(Tokenize);

